import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Icon from './Icon.svelte';

export default function Plus($$anchor, $$props) {
	const iconNode = [["path", { "d": "M5 12h14" }], ["path", { "d": "M12 5v14" }]];
	let rest = $.rest_props($$props, ['$$slots', '$$events', '$$legacy']);

	Icon($$anchor, $.spread_props(
		{
			get iconNode() {
				return iconNode;
			}
		},
		() => rest
	));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiUGx1cy5zdmVsdGUiXSwic291cmNlc0NvbnRlbnQiOlsiPHNjcmlwdCBsYW5nPVwidHNcIj5cbiAgaW1wb3J0IEljb24gZnJvbSAnLi9JY29uLnN2ZWx0ZSc7XG4gIGNvbnN0IGljb25Ob2RlOiBbc3RyaW5nLCBSZWNvcmQ8c3RyaW5nLCBzdHJpbmc+XVtdID0gW1tcInBhdGhcIiwgeyBcImRcIjogXCJNNSAxMmgxNFwiIH1dLCBbXCJwYXRoXCIsIHsgXCJkXCI6IFwiTTEyIDV2MTRcIiB9XV07XG4gIGxldCByZXN0ID0gJHByb3BzKCk7XG48L3NjcmlwdD5cbjxJY29uIHtpY29uTm9kZX0gey4uLnJlc3R9IC8+XG4iXSwibWFwcGluZ3MiOiI7O09BQ1MsSUFBSSxNQUFNLGVBQWU7O2dEQURsQyxDQUFDO09BRU8sUUFBNEMsS0FBSyxNQUFNLElBQUksR0FBRyxFQUFFLFVBQVUsTUFBTSxNQUFNLElBQUksR0FBRyxFQUFFLFVBQVU7S0FDM0csSUFBSTs7Ozs7Ozs7UUFFVyxJQUFJOztBQUQxQixDQUFDIn0=